export const constants = {
    apiPath: process.env.REACT_APP_API_PATH as string,
};
